import { Component, OnInit, inject, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule, formatDate } from '@angular/common';
import { DomSanitizer, SafeResourceUrl   } from "@angular/platform-browser";
import { NgbDatepickerModule, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ModalComponent } from "../../../modal/modal.component";
import { InicioService } from '../../../../services/inicio.service';
import { UsuarioService } from '../../../../services/usuario.service';
import { I18n, CustomDatepickerI18n } from '../../../../clases/idioma-fecha';
import { appsettings } from '../../../../settings/appsettings';

@Component({
  selector: 'app-agregar',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule, NgbDatepickerModule, ReactiveFormsModule, NgxMaskDirective],
  templateUrl: './agregar.component.html',
  styleUrl: './agregar.component.css',
  providers: [
    provideNgxMask(),
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
  ],
})
export class AgregarComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Output() vuelve = new EventEmitter<any>();
  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;
  errorMessage: string = '';


  cmbDiscapacidad: boolean = false;
  cmbGrupoEtnico: boolean = false;

  tieneHijo: boolean = false;
  etinico: boolean = false;
  tieneCertificado: boolean = false;
  valida_hijos: boolean = false;
  datosEstudiante: any = [];
  documentos: any = [];
  edad: number = 0;
  archivos_pdf: any = [];

  txtNotas: string = 'Cargar .PDF';
  txtConstancia: string = 'Cargar .PDF';
  txtFotografia: string = 'Cargar .PDF';
  txtCarnet: string = 'Cargar .PDF';
  txtCedula: string = 'Cargar .PDF';
  txtRepresentante: string = 'Cargar .PDF';
  txtSalud: string = 'Cargar .PDF';
  txtRif: string = 'Cargar .PDF';
  txtCurriculum: string = 'Cargar .PDF';
  txtReferencia: string = 'Cargar .PDF';
  txtLopna: string = 'Cargar .PDF';

  valNotas: SafeResourceUrl | null = null;
  valConstancia: SafeResourceUrl | null = null;
  valFotografia: SafeResourceUrl | null = null;
  valCarnet: SafeResourceUrl | null = null;
  valCedula: SafeResourceUrl | null = null;
  valRepresentante: SafeResourceUrl | null = null;
  valSalud: SafeResourceUrl | null = null;
  valRif: SafeResourceUrl | null = null;
  valCurriculum: SafeResourceUrl | null = null;
  valReferencia: SafeResourceUrl | null = null;
  valLopna: SafeResourceUrl | null = null;

  id_pais_re: string = '228';

  fliNotas: any = [];
  fliConstancia: any = [];
  fliFotografia: any = [];
  fliCarnet: any = [];
  fliCedula: any = [];
  fliRepresentante: any = [];
  fliSalud: any = [];
  fliRif: any = [];
  fliCurriculum: any = [];
  fliReferencia: any = [];
  fliLopna: any = [];


  arrOcupa: any | undefined;
  arrPais: any | undefined;
  arrEstado: any | undefined;
  arrOperadora: any | undefined;
  arrOperadoraMovil: any | undefined;
  arrMunicipio: any | undefined;
  arrParroquia: any | undefined;
  arrProgramaInces: any | undefined;
  arrGrupoEtnico: any | undefined;
  arrDiscapacidad: any | undefined;

  private srvLogin = inject(InicioService);
  private servicios = inject(UsuarioService);
  private sanitizer = inject(DomSanitizer);
  //private fb = inject(FormBuilder)
  private url = appsettings.apiUrl;

  formularioRegistro: FormGroup;



  constructor( private fb:FormBuilder ){
    this.formularioRegistro = this.fb.group({
        //--------Datos personales
        id_pais: ['', Validators.required],
        nro_doc: ['', Validators.required],
        documento: ['', Validators.required],
        nombre: ['', Validators.required],
        apellido: ['', Validators.required],
        genero: ['', Validators.required],
        fch_nacimiento: ['', Validators.required],
        edad: ['', Validators.required],
        edo_civil: ['', Validators.required],
        lugar_nacimiento: ['', Validators.required],
        tiene_hijos: [false],
        indique_hijos: [''],
        otros_hijos: [''],
        grupo_etnico: [false],
        indique_etnia: [''],
        discapacidad: [false],
        indique_discapacidad: [''],
        certificado_discapacidad: [false],
        tp_dis: [''],
        numero_discapacidad: [''],
        //--------Datos constacto
        pais_residencia: [this.id_pais_re],
        estado: ['', Validators.required],
        municipio: ['', Validators.required],
        parroquia: ['', Validators.required],
        ciudad: ['', Validators.required],
        sector: ['', Validators.required],
        direccion_residencia: ['', Validators.required],
        tipo_operadora: [''],
        tlf_local: [''],
        tipo_operadora_movil: ['', Validators.required],
        tlf_local_movil: ['', Validators.required],
        correo: ['', Validators.required],
        //--------Datos academicos
        grado_instruccion: ['', Validators.required],
        ultimo_ano: ['', Validators.required],
        password: [''],
        re_password: ['']
    });
  }


  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.listarDatosCombo().subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.arrPais = rs.data[0].pais;
        this.arrEstado = rs.data[0].estado;
        this.arrOperadora = rs.data[0].operadora_local;
        this.arrOperadoraMovil = rs.data[0].operadora_movil;
        this.arrDiscapacidad = rs.data[0].discapacidad;
        this.arrGrupoEtnico = rs.data[0].grupo_etnico;
        console.table('todos los datos:   ',rs.data[0]);
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }


  // Este método 'transform' ya lo tenías y es correcto,
  // pero asegúrate de llamarlo explícitamente en los lugares donde asignas las URLs.
  transform(url: any): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ver_pass(tipo: number){
    let pass = tipo == 1 ? (document.getElementById('password') as HTMLInputElement) : (document.getElementById('re_password') as HTMLInputElement);
    pass.getAttribute('type') == 'password' ? pass.setAttribute('type', 'text') : pass.setAttribute('type', 'password');
  }

  hijos(ev: any){
    this.tieneHijo = (ev.target.checked) ? true : false;
    if(!ev.target.checked){
      this.formularioRegistro?.get('indique_hijos')?.setValue('');
      this.formularioRegistro?.get('otros_hijos')?.setValue('');
      this.valida_hijos = false;
    }
  }

  verifica_hijo(ev: any){
    this.formularioRegistro?.get('otros_hijos')?.setValue('');
    this.valida_hijos = ev.target.value == 3 ? true : false;
  }

  convierteDtpick(date: string):NgbDateStruct {
    let array = date.split("-");
    return {year: parseInt(array[2]), month: parseInt(array[1]), day: parseInt(array[0])};
  }

  convertidor(numero: number): string {
    return numero < 10 ? `0${numero}` : numero.toString();
  }

  calcula_edad(){
    const fch_nac = this.formularioRegistro.get('fch_nacimiento')?.value;
    let fch = `${this.convertidor(fch_nac['year'])}-${this.convertidor(fch_nac['month'])}-${this.convertidor(fch_nac['day'])}`
    let fecha1 = new Date(fch);
    let fecha2 = new Date()
    let resta = fecha2.getTime() - fecha1.getTime()
    this.edad = (Math.ceil((Math.round(resta/ (1000*60*60*24)))/365))-1;
    this.formularioRegistro?.get('edad')?.setValue(this.edad);
  }

  municipio(){
    this.mdl.cargando();
    this.servicios.municipio(this.formularioRegistro.get('estado')?.getRawValue()).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.arrMunicipio = rs.data;
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  parroquia(){
    this.mdl.cargando();
    this.servicios.parroquia(this.formularioRegistro.get('municipio')?.getRawValue()).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.arrParroquia = rs.data;
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  validaDiscapacidad(ev: any){
    this.cmbDiscapacidad = ev.target.checked;
    //console.log('target:  ',ev.target.checked)
  }

  validaGrupoEtnico(ev: any){
    this.cmbGrupoEtnico = ev.target.checked;
    //console.log('target:  ',ev.target.checked)
  }

  certificadoDiscapacidad(ev: any){
    this.tieneCertificado = ev.target.checked
  }

  cambia(tipo: number, event: any){
    const input = event.target as HTMLInputElement;
    if(tipo == 1){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          // 1. Crear la URL del objeto
          //this.rawObjectUrl = URL.createObjectURL(input.files[0]);
          // 2. Sanitizar la URL para que Angular la considere segura
          // Para iframes, usamos bypassSecurityTrustResourceUrl
          this.valNotas = this.transform(URL.createObjectURL(input.files[0]));
          this.txtNotas = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });

          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('documento')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }

          // Paso 1: Comprobar si existe el objeto 'notas'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('notas'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'notas' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('notas'));
            this.archivos_pdf?.push({notas: envio});
          } else {
            console.log("El objeto 'notas' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({notas: envio});
          }
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          console.log('datos a enviar Notas certificadas :   ', envio);
        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 2){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valConstancia = this.transform(URL.createObjectURL(input.files[0]));
          this.txtConstancia = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });

          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('documento')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }

          //this.archivos_pdf?.push({comprobante: envio});
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          // Paso 1: Comprobar si existe el objeto 'comprobante'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('constancia'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'constancia' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('constancia'));
            this.archivos_pdf?.push({constancia: envio});
          } else {
            console.log("El objeto 'constancia' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({constancia: envio});
          }
          console.log('datos a enviar Comprobante de aprobación  :   ', envio);
        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 3){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valFotografia = this.transform(URL.createObjectURL(input.files[0]));
          this.txtFotografia = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });

          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('documento')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }

          //this.archivos_pdf?.push({fotografia: envio});
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          // Paso 1: Comprobar si existe el objeto 'fotografia'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('fotografia'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'fotografia' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('fotografia'));
            this.archivos_pdf?.push({fotografia: envio});
          } else {
            console.log("El objeto 'fotografia' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({fotografia: envio});
          }
          console.log('datos a enviar Fotografía tipo carnet :   ', envio);

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 4){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valCarnet = this.transform(URL.createObjectURL(input.files[0]));
          this.txtCarnet = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });

          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('documento')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }

          //this.archivos_pdf?.push({acta: envio});
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          // Paso 1: Comprobar si existe el objeto 'acta'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('carnet'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'carnet' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('carnet'));
            this.archivos_pdf?.push({carnet: envio});
          } else {
            console.log("El objeto 'carnet' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({carnet: envio});
          }
          console.log('datos a enviar Acta de nacimiento :   ', envio);

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 5){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valCedula = this.transform(URL.createObjectURL(input.files[0]));
          this.txtCedula = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });

          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('documento')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }

          //this.archivos_pdf?.push({documento: envio});
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          // Paso 1: Comprobar si existe el objeto 'documento'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('cedula'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'cedula' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('cedula'));
            this.archivos_pdf?.push({cedula: envio});
          } else {
            console.log("El objeto 'cedula' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({cedula: envio});
          }
          console.log('datos a enviar Documento de identidad :   ', envio);

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 6){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valRepresentante = this.transform(URL.createObjectURL(input.files[0]));
          this.txtRepresentante = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });

          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('documento')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }

          //this.archivos_pdf?.push({comprobante: envio});
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          // Paso 1: Comprobar si existe el objeto 'comprobante'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('representante'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'representante' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('representante'));
            this.archivos_pdf?.push({representante: envio});
          } else {
            console.log("El objeto 'representante' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({representante: envio});
          }
          console.log('datos a enviar Comprobante de aprobación  :   ', envio);
        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 7){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valSalud = this.transform(URL.createObjectURL(input.files[0]));
          this.txtSalud = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });

          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('documento')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }

          //this.archivos_pdf?.push({fotografia: envio});
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          // Paso 1: Comprobar si existe el objeto 'fotografia'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('salud'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'salud' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('salud'));
            this.archivos_pdf?.push({salud: envio});
          } else {
            console.log("El objeto 'salud' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({salud: envio});
          }
          console.log('datos a enviar Fotografía tipo carnet :   ', envio);

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 8){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valRif = this.transform(URL.createObjectURL(input.files[0]));
          this.txtRif = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });

          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('documento')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }

          //this.archivos_pdf?.push({acta: envio});
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          // Paso 1: Comprobar si existe el objeto 'acta'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('rif'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'rif' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('rif'));
            this.archivos_pdf?.push({rif: envio});
          } else {
            console.log("El objeto 'rif' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({rif: envio});
          }
          console.log('datos a enviar Acta de nacimiento :   ', envio);

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 9){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valCurriculum = this.transform(URL.createObjectURL(input.files[0]));
          this.txtCurriculum = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });

          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('documento')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }

          //this.archivos_pdf?.push({documento: envio});
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          // Paso 1: Comprobar si existe el objeto 'documento'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('curriculum'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'curriculum' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('curriculum'));
            this.archivos_pdf?.push({curriculum: envio});
          } else {
            console.log("El objeto 'curriculum' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({curriculum: envio});
          }
          console.log('datos a enviar Documento de identidad :   ', envio);

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 10){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valReferencia = this.transform(URL.createObjectURL(input.files[0]));
          this.txtReferencia = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });

          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('documento')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }

          //this.archivos_pdf?.push({acta: envio});
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          // Paso 1: Comprobar si existe el objeto 'acta'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('referencia'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'referencia' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('referencia'));
            this.archivos_pdf?.push({referencia: envio});
          } else {
            console.log("El objeto 'referencia' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({referencia: envio});
          }
          console.log('datos a enviar Acta de nacimiento :   ', envio);

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }
    else if(tipo == 11){
      if (input.files && input.files.length > 0) {
        if (input.files[0].type === 'application/pdf') {
          this.valLopna = this.transform(URL.createObjectURL(input.files[0]));
          this.txtLopna = input.files[0].name;
          var blob: Blob = new Blob([input.files[0]], { type: input.files[0].type });

          const envio = {
            "nombre_archivo": input.files[0].name,
            "cedula": this.formularioRegistro.get('documento')?.getRawValue(),
            "tipo": tipo,
            "archivo": blob
          }

          //this.archivos_pdf?.push({documento: envio});
          //console.log('Objeto URL PDF creado:', URL.createObjectURL(input.files[0]));
          // Paso 1: Comprobar si existe el objeto 'documento'
          const existe = this.archivos_pdf.some((item: any) => item.hasOwnProperty('lopna'));
          // Paso 2: Si existe, entonces crea un nuevo array sin él
          if (existe) {
            console.log("El objeto 'lopna' fue encontrado y eliminado.");
            this.archivos_pdf = this.archivos_pdf.filter((item: any) => !item.hasOwnProperty('lopna'));
            this.archivos_pdf?.push({lopna: envio});
          } else {
            console.log("El objeto 'lopna' no fue encontrado en el array, por ende se agrego.");
            this.archivos_pdf?.push({lopna: envio});
          }
          console.log('datos a enviar Documento de identidad :   ', envio);

        } else {
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = 'Por favor, selecciona un archivo PDF (.pdf).';
          this.mdl.alerta();
        }
      }
    }


    console.log('arreglo de  archivos:  ',this.archivos_pdf)

  }

  subir_archivo(datos: any){
    this.servicios.subir_archivo(datos).subscribe({
      next: (rs) => {
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  guardar_todo(){

    let passRegex = /^(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*\d)(?=.*[a-z]).{8,}$/;
    let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    let pass = this.formularioRegistro.get('password')?.getRawValue();
    let mail = this.formularioRegistro.get('correo')?.getRawValue();
    let valor: boolean = true;
    if(!this.formularioRegistro.valid){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = "Debe completar los campos requeridos del formulario (*)";
      this.mdl.alerta();
      valor = false;
    }
    else if(pass != '' || this.formularioRegistro.get('re_password')?.getRawValue() != ''){
      if(!passRegex.test(pass)){
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        //this.mensaje = "La contraseña no cumple con las características de validación. Por favor presione el botón de ('Indicaciones para crear la contraseña...') ";
        this.mensaje = "La contraseña no cumple con las características de validación.";
        this.mdl.alerta();
        valor = false;
      }else if(pass != this.formularioRegistro.get('re_password')?.getRawValue()){
        this.titulo = '!ADVERTENCIA¡';
        this.tipo_color = 'warning';
        this.letra_color = 'dark';
        this.mensaje = "Las contraseñas deben ser iguales";
        this.mdl.alerta();
        valor = false;
      }
      else{
        valor = true;
      }
    }
    else if(!emailRegex.test(mail)){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      //this.mensaje = "La contraseña no cumple con las características de validación. Por favor presione el botón de ('Indicaciones para crear la contraseña...') ";
      this.mensaje = "Por favor ingrese un correo válido.";
      this.mdl.alerta();
      valor = false;
    }
    else{
      valor = true;
    }


    if(valor){

      //aplica solo caundo se va a enviar en vista de que si no se ejecuta el
      //servicio da error ya que modificamos las variables del formGroup
      let val1 = this.formularioRegistro.get('tp_dis')?.getRawValue();
      let val2 = this.formularioRegistro.get('numero_discapacidad')?.getRawValue();
      let combinado = `${val1}-${val2}`;
      let fch_nac = this.formularioRegistro.get('fch_nacimiento')?.getRawValue();
      let fch = `${this.convertidor(fch_nac['year'])}-${this.convertidor(fch_nac['month'])}-${this.convertidor(fch_nac['day'])}`
      this.formularioRegistro.get('fch_nacimiento')?.setValue(fch);
      (this.formularioRegistro.value).numero_discapacidad = combinado;
      //console.log('todos: ', this.formularioRegistro.value)

      this.mdl.cargando();
      this.servicios.registrarEstudiante(this.formularioRegistro.value).subscribe({
        next: (rs) => {
          console.log('datos llegada: ',rs.data)
          this.archivos_pdf.forEach((dt:any) => {
            if(dt.hasOwnProperty('notas'))this.subir_archivo(dt['notas']);
            if(dt.hasOwnProperty('comprobante'))this.subir_archivo(dt['comprobante']);
            if(dt.hasOwnProperty('fotografia'))this.subir_archivo(dt['fotografia']);
            if(dt.hasOwnProperty('acta'))this.subir_archivo(dt['acta']);
            if(dt.hasOwnProperty('documento'))this.subir_archivo(dt['documento']);
          });
          this.servicios.finaliza_registro(this.formularioRegistro.get('documento')?.getRawValue()).subscribe({
            next:(dt)=>{
              this.mdl.cerrar();
              this.vuelve.emit({value: false, validador: true});
            }
          })
        },
        error: (error) => {
          this.errorMessage = error.message; // Muestra el mensaje de error al usuario
          //console.error("Error en el componente:", error); // Registro del error en el componente
        }
      });

    }

  }


  volver(){
    this.vuelve.emit({value: false, validador: false});
  }

}
